import { createRouter, createWebHashHistory } from 'vue-router';
import { user } from '@/auth';

const routes = [
  {
    path: '/login',
    name: 'AuthLayout',
    component: () => import(/* webpackChunkName: "authLayout" */ '../layouts/AuthLayout.vue'),
    children: [
      {
        path: '',
        name: 'Login',
        component: () => import(/* webpackChunkName: "authView" */ '../views/AuthView.vue'),
      },
    ],
  },
  {
    path: '/',
    name: 'DefaultLayout',
    component: () => import(/* webpackChunkName: "defaultLayout" */ '../layouts/DefaultLayout.vue'),
    children: [
      {
        path: '',
        name: 'Home',
        component: () => import(/* webpackChunkName: "homeView" */ '../views/HomeView.vue'),
      },
      {
        path: '/category/:categoryId',
        name: 'CategoryView',
        props: true,
        component: () => import(/* webpackChunkName: "categoryView" */ '../views/CategoryView.vue'),
      },
      {
        path: '/report',
        name: 'ReportView',
        component: () => import(/* webpackChunkName: "reportView" */ '../views/ReportView.vue'),
      },
      {
        path: '/period',
        name: 'PeriodView',
        component: () => import(/* webpackChunkName: "PeriodView" */ '../views/PeriodView.vue'),
      },
    ],
  },
];

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to) {
    if (to.hash) {
      setTimeout(() => {
        window.scrollTo({
          top: document.querySelector(to.hash).offsetTop,
          behavior: 'smooth',
        });
      }, 50);
    }
    setTimeout(() => {
      window.scrollTo({ top: 0 });
    }, 100);
  },
});

router.beforeEach((to, from, next) => {
  const authenticated = !!user().token;

  if (!to.meta.public) {
    if (to.name === undefined) {
      next({ name: 'NotFound' });
    } else if (to.name === 'Login' && !authenticated) {
      next();
    } else if (to.name === 'Login' && authenticated) {
      next({ name: 'Home' });
    } else if (to.name !== 'Login' && !authenticated) {
      next({ name: 'Login' });
    } else if (to.meta.public && !to.meta.isPrivate) {
      next();
    } else if (from.query.facilityId && !to.query.facilityId) {
      // eslint-disable-next-line no-param-reassign
      to.query.facilityId = from.query.facilityId;
      next({ name: to.name, params: to.params, path: to.path, query: to.query });
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;
